import { Tooltip, Button, Card, Col, Icon, Row } from "antd";
import { UserOutlined } from "@ant-design/icons";
import React, { Component } from "react";
import withSharedStateConsumer from "../../../contexts/shared-state/withSharedStateConsumer";
import "./ExpandableCard.css";
import { Translation } from "react-i18next";
import i18next from "i18next";
class ExpandableCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showInnerCard: false,
    };
  }

  showInnerCard(showInnerCard) {
    this.setState({ showInnerCard: !showInnerCard });
  }

  showStatusIcon(status) {
    let langAndDir = this.props.context;
    if (status === "ADMIN") {
      return (
        <Tooltip placement="top" title={i18next.t("Admin")}>
          <Button
            disabled
            icon="user"
            shape="circle"
            style={
              langAndDir.curr_dir === "ltr" && langAndDir.curr_lang === "en"
                ? {
                    padding: "3px 0px 0px 1.5px",
                    marginLeft: "10px",
                    backgroundColor: "#3d4546",
                    borderColor: "#3d4546",
                    color: "white",
                  }
                : {
                    padding: "3px 1.5px 0px 0px",
                    marginRight: "10px",
                    backgroundColor: "#3d4546",
                    borderColor: "#3d4546",
                    color: "white",
                  }
            }
          />
        </Tooltip>
      );
    } else if (status === "INT") {
      return (
        <Tooltip placement="top" title={i18next.t("Initial")}>
          <Button
            disabled
            shape="circle"
            style={
              langAndDir.curr_dir === "ltr" && langAndDir.curr_lang === "en"
                ? {
                    padding: "3px 0px 0px 1.5px",
                    marginLeft: "10px",
                    backgroundColor: "#82b3d2",
                    borderColor: "#82b3d2",
                    color: "white",
                  }
                : {
                    padding: "3px 1.5px 0px 0px",
                    marginRight: "10px",
                    backgroundColor: "#82b3d2",
                    borderColor: "#82b3d2",
                    color: "white",
                  }
            }
            icon="info"
          ></Button>
        </Tooltip>
      );
    } else if (status === "DEL") {
      return (
        <Tooltip placement="top" title={i18next.t("Deleted")}>
          <Button
            disabled
            shape="circle"
            style={
              langAndDir.curr_dir === "ltr" && langAndDir.curr_lang === "en"
                ? {
                    padding: "3px 0px 0px 1.5px",
                    marginLeft: "10px",
                    backgroundColor: "#f6413a",
                    borderColor: "#f6413a",
                    color: "white",
                  }
                : {
                    padding: "3px 1.5px 0px 0px",
                    marginRight: "10px",
                    backgroundColor: "#f6413a",
                    borderColor: "#f6413a",
                    color: "white",
                  }
            }
          >
            <Icon type="close" />
          </Button>
        </Tooltip>
      );
    } else if (status === "ACT") {
      return (
        <Tooltip placement="top" title={i18next.t("Active")}>
          <Button
            disabled
            icon="check"
            shape="circle"
            style={
              langAndDir.curr_dir === "ltr" && langAndDir.curr_lang === "en"
                ? {
                    padding: "3px 0px 0px 1.5px",
                    marginLeft: "10px",
                    backgroundColor: "#52c41a",
                    borderColor: "#52c41a",
                    color: "white",
                  }
                : {
                    padding: "3px 1.5px 0px 0px",
                    marginRight: "10px",
                    backgroundColor: "#52c41a",
                    borderColor: "#52c41a",
                    color: "white",
                  }
            }
          />
        </Tooltip>
      );
    } else if (status === "SUS") {
      return (
        <Tooltip placement="top" title={i18next.t("Suspended")}>
          <Button
            disabled
            icon="close"
            shape="circle"
            style={
              langAndDir.curr_dir === "ltr" && langAndDir.curr_lang === "en"
                ? {
                    padding: "3px 0px 0px 1.5px",
                    marginLeft: "10px",
                    backgroundColor: "#f39c12",
                    borderColor: "#f39c12",
                    color: "white",
                  }
                : {
                    padding: "3px 1.5px 0px 0px",
                    marginRight: "10px",
                    backgroundColor: "#f39c12",
                    borderColor: "#f39c12",
                    color: "white",
                  }
            }
          />
        </Tooltip>
      );
    } else if (status === "OFFLINE") {
      return (
        <Tooltip placement="top" title={i18next.t("Offline")}>
          <Button
            disabled
            icon="close"
            shape="circle"
            style={
              langAndDir.curr_dir === "ltr" && langAndDir.curr_lang === "en"
                ? {
                    padding: "3px 0px 0px 1.5px",
                    marginLeft: "10px",
                    backgroundColor: "#f6413a",
                    borderColor: "#f6413a",
                    color: "white",
                  }
                : {
                    padding: "3px 1.5px 0px 0px",
                    marginRight: "10px",
                    backgroundColor: "#f6413a",
                    borderColor: "#f6413a",
                    color: "white",
                  }
            }
          />
        </Tooltip>
      );
    } else if (status === "ONLINE") {
      return (
        <Tooltip placement="top" title={i18next.t("Online")}>
          <Button
            disabled
            icon="check"
            shape="circle"
            style={
              langAndDir.curr_dir === "ltr" && langAndDir.curr_lang === "en"
                ? {
                    padding: "3px 0px 0px 1.5px",
                    marginLeft: "10px",
                    backgroundColor: "#52c41a",
                    borderColor: "#52c41a",
                    color: "white",
                  }
                : {
                    padding: "3px 1.5px 0px 0px",
                    marginRight: "10px",
                    backgroundColor: "#52c41a",
                    borderColor: "#52c41a",
                    color: "white",
                  }
            }
          />
        </Tooltip>
      );
    } else if (status === "BREAK") {
      return (
        <Tooltip placement="top" title={i18next.t("Break")}>
          <Button
            disabled
            icon="coffee"
            shape="circle"
            style={
              langAndDir.curr_dir === "ltr" && langAndDir.curr_lang === "en"
                ? {
                    padding: "3px 0px 0px 1.5px",
                    marginLeft: "10px",
                    backgroundColor: "#873e23",
                    borderColor: "#873e23",
                    color: "white",
                  }
                : {
                    padding: "3px 1.5px 0px 0px",
                    marginRight: "10px",
                    backgroundColor: "#873e23",
                    borderColor: "#873e23",
                    color: "white",
                  }
            }
          />
        </Tooltip>
      );
    } else if (status === "AUX") {
      return (
        <Tooltip placement="top" title={i18next.t("Auxiliary")}>
          <Button
            disabled
            icon="minus"
            shape="circle"
            style={
              langAndDir.curr_dir === "ltr" && langAndDir.curr_lang === "en"
                ? {
                    padding: "3px 0px 0px 1.5px",
                    marginLeft: "10px",
                    backgroundColor: "#f6413a",
                    borderColor: "#f6413a",
                    color: "white",
                  }
                : {
                    padding: "3px 1.5px 0px 0px",
                    marginRight: "10px",
                    backgroundColor: "#f6413a",
                    borderColor: "#f6413a",
                    color: "white",
                  }
            }
          />
        </Tooltip>
      );
    }
  }
  render() {
    let langAndDir = this.props.context;
    return (
      <Card
        style={{
          marginTop: "10px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
        }}
        bordered={false}
      >
        <Row style={{ padding: "10px", paddingTop: "20px" }}>
          <Col xs={2} lg={1}>
            {this.props.type === "ADMIN"
              ? this.showStatusIcon("ADMIN")
              : this.showStatusIcon(this.props.status)}
          </Col>
          <Col
            xs={19}
            lg={20}
            className="gutter-box"
            style={
              langAndDir.curr_dir === "ltr" && langAndDir.curr_lang === "en"
                ? { marginLeft: "3px" }
                : { marginRight: "3px" }
            }
            onClick={() => this.showInnerCard(this.state.showInnerCard)}
          >
            <p>{this.props.title}</p>
          </Col>

          <Col
            style={
              langAndDir.curr_dir === "ltr" && langAndDir.curr_lang === "en"
                ? { marginRight: "5px", borderRight: "2px solid #cccccc" }
                : {
                    marginLeft: "5px",
                    borderLeft: "2px solid #cccccc",
                  }
            }
            xs={2}
            lg={1}
          >
            {this.props.renderDropDown}
          </Col>

          <Col xs={0} lg={1}>
            <Button
              style={
                langAndDir.curr_dir === "ltr" && langAndDir.curr_lang === "en"
                  ? {
                      marginTop: "-5px",
                      borderWidth: 0,
                      float: "right",
                    }
                  : { marginTop: "-5px", borderWidth: 0, float: "left" }
              }
              onClick={() => this.showInnerCard(this.state.showInnerCard)}
            >
              {this.state.showInnerCard ? (
                <Icon type="up" />
              ) : (
                <Icon type="down" />
              )}
            </Button>
          </Col>
        </Row>
        {this.state.showInnerCard && (
          <Row
            style={{
              backgroundColor: "#ececec",
              padding: "10px",
              borderBottomRightRadius: "6px",
              borderBottomLeftRadius: "6px",
            }}
          >
            {this.props.renderDetails}
          </Row>
        )}
      </Card>
    );
  }
}

export default withSharedStateConsumer(ExpandableCard);
